import { useState } from "react";
import AccountMail from "~/assets/icons/AccountMail";
import AccountName from "~/assets/icons/AccountName";
import AccountPhone from "~/assets/icons/AccountPhone";
import BlackCircleLoading from "~/assets/icons/BlackCircleLoading";
import { callSendEmail } from "~/lib/utils";
import { SetupProductRequestForm } from "../../../../setup/components/setup/productDetail/SetupProductRequestForm.client";
import { ProductMetafields } from "~/types";
type RequestPriceFormProp = {
    customForm: boolean,
    product: ProductMetafields
}
export function RequestPriceForm({ product, customForm }: RequestPriceFormProp) {
    return (
        <>
            {customForm ? <SetupProductRequestForm product={product} /> : <DefaultRequestPriceForm />}
        </>
    )
}

const DefaultRequestPriceForm = () => {
    const [form, setForm] = useState({ name: '', email: '', phone: '' })
    const [loading, setLoading] = useState(false);
    const [hasSubmitError, setHasSubmitError] = useState(false);
    const [hasSubmitSuccess, setHasSubmitSuccess] = useState(false);

    const onChange = (event) => {
        setForm(old => ({ ...old, [event.target.id]: event.target.value }))
    }

    const emptyInputForm = () => {
        setForm({ name: '', email: '', phone: '' })
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true);
        await sendMail();
    }

    const sendMail = async () => {
        const response = await callSendEmail(form);
        if (response.error) {
            setLoading(false)
            setHasSubmitError(false)
        } else {
            setLoading(false)
            setHasSubmitSuccess(true)
            emptyInputForm()
        }
    }

    return (
        <div className="requestPrice">
            <h1>Request Price</h1>
            <p>Complete these details and we will contact you</p>
            <div className="formContainer">
                <form className="customForm" onSubmit={handleSubmit}>
                    <div className="nameIcon"><AccountName />
                        <input type="text" id="name" required placeholder="Name*" onChange={onChange}></input>
                    </div>
                    <div className="emailIcon"><AccountMail />
                        <input type="email" required id="email" placeholder="Email*" onChange={onChange}></input>
                    </div>
                    <div className="phoneIcon"><AccountPhone />
                        <input type="text" required id="phone" placeholder="Phone*" onChange={onChange}></input>
                    </div>
                    <button type="submit" className="black-button">
                        {!loading ? 'Request Price' :
                            <div className="text-center">LOADING  <BlackCircleLoading /></div>
                        }
                    </button>
                </form>
                {hasSubmitError && (
                    <div className="flex items-center justify-center mb-6">
                        <p className="m-4 text-s text-red-500">
                            Sorry, the request could not be sent. Please try again.
                        </p>
                    </div>
                )}
                {hasSubmitSuccess && (
                    <div className="flex items-center justify-center mb-6">
                        <p className="m-4 text-s text-green-500">
                            Your request was sent successfully.
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}